import { Injectable } from '@angular/core';

import { Docorga } from '@docorga-v1/docorga-common';

import { DataService } from './data.service';
import { DocumentService } from './document.service';

@Injectable()
export class QuotationService extends Docorga.services.QuotationService {
  constructor(protected DataService: DataService, protected DocumentService: DocumentService) {
    super(DataService, DocumentService);
  }
}
